
/**
 * @file src/package/bridge/index.ts
 * @author huangxueping
 * @description 将原生的插件方法暴露出去
 */
import messagener from './messagener';

/**
 * 返回上一个页面
 */
function back() {
    return messagener.exec('BCENativeActionPlugin', 'backPreviousPage');
}

/**
 * 关闭当前 webview，返回原生
 */
function close() {
    return messagener.exec('BCENativeActionPlugin', 'backToNative');
}

/**
 * 支付宝支付
 * @param payInfo 订单信息
 */
function alipay(payInfo: string) {
    return messagener.exec('BCENativeActionPlugin', 'alipay', {payInfo});
}

/**
 * 导航栏右侧菜单配置
 * @param option 配置信息
 * title        : 标题
 * iconUrl      : 图标资源地址
 * color        : '#ff00ff', 必须以 ＃开始的 rgb 颜色值
 * hide         : 隐藏状态
 * callback     : 回调方法
 */
function setOptionMenu(option: any) {
    return messagener.exec('BCENativeActionPlugin', 'setOptionMenu', option);
}

export default {
    back,
    close,
    alipay,
    setOptionMenu,
};
